"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
var Environment = /*#__PURE__*/
function () {
  _createClass(Environment, null, [{
    key: "get",
    value: function get() {
      return new Environment().environment();
    }
  }, {
    key: "prefix",
    value: function prefix() {
      return new Environment().prefix();
    }
  }]);
  function Environment() {
    _classCallCheck(this, Environment);
    this.host = this._getHostname();
  }
  _createClass(Environment, [{
    key: "environment",
    value: function environment() {
      // In order to access a server running on localhost through a tool
      // like VirtualBox, you need to use an IP address like "10.0.2.2".
      // To prevent logs from going to production in these cases, check
      // if the host is an IP address. If so, assume we're in "dev."
      //
      // Regex Playground:
      // https://regex101.com/r/QRbH0j/1
      if (this.host.match(/^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})$/)) {
        return 'dev';
      } // Some devs mask their localhost with a ".local" prefix
      // e.g. "127.0.0.1" -> "elp.local.daveramsey.com".
      // This is another check to see if we are in "dev"

      if (this.host.indexOf('.local') > -1) {
        return 'dev';
      }
      if (this.host.indexOf('localhost') > -1) {
        return 'dev';
      }
      if (this.host.indexOf('test.') > -1) {
        return 'test';
      }
      if (this.host.indexOf('qa.') > -1) {
        return 'qa';
      }
      return 'prod';
    }
  }, {
    key: "prefix",
    value: function prefix() {
      var env = this.environment();
      var prefixes = {
        dev: 'test.',
        test: 'test.',
        qa: 'qa.',
        prod: ''
      };
      return prefixes[env];
    }
  }, {
    key: "_getHostname",
    value: function _getHostname() {
      return window.location.hostname;
    }
  }]);
  return Environment;
}();
exports["default"] = Environment;